import { getLastDataYear } from '../bereiche/datenauswertung/helper/getLastDataYear';
import { getStandorte } from './getStandorte';
import { getVeranstaltungen } from './getVeranstaltungen';
import { IDs } from './IDs';
import { RoutingIDs } from './RoutingIDs';
import { findStandorteTabRouting, getStandorteGruppenTabRoutings } from '../bereiche/dateneingabe/functions/StandorteGruppen';

export function getRoutingEnergiedaten(data: any, standort: number, entities?: string[], energietraeger?: number): any {
    data = data || {};
    energietraeger = energietraeger || null;
    entities = entities || [];
    standort = +standort || null;
    const isGefuehrterModus: boolean = (data[IDs.ENT_KONFIGURATION] || []).some((param: any) => param.gefuehrter_modus_orig === 1);
    let jahr: number = null;
    getLastDataYear(
        new Date().getFullYear(), data, { energietraeger, entities, invalidData: true, standort },
        (item: any) => {
            jahr = +item.jahr || jahr;
            standort = +item.standort || standort;
        }
    );
    const standorte: any[] = (getStandorte(data) || []).map((standort: any) => standort.tid);
    const veranstaltungen: any[] = (getVeranstaltungen(data) || []).map((standort: any) => standort.tid);

    // let index: number = standorte.indexOf(standort);
    // index = index === -1 && veranstaltungen.indexOf(standort) !== -1 ? standorte.length : index;

    // Tab-Routing
    let standortRoutingFnd: any = {};
    const istVeranstaltung = getVeranstaltungen(data).find((s: any) => s.tid === standort);
    if (!istVeranstaltung) {
        standortRoutingFnd = findStandorteTabRouting(standort, data, RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX, RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX) || {};
    } else {
        const basisRouting = RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX;
        const basisTab = RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX;
        const tabRoutings = getStandorteGruppenTabRoutings(data, basisRouting, basisTab);
        standortRoutingFnd = {
            path: {
                ...basisRouting,
                [basisTab]: tabRoutings.length,
                terminateOn: basisTab
            }
        };
    }

    const path: any = isGefuehrterModus ? RoutingIDs.ROUTE_DATENEINGABE :
        {
            // ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX,
            // [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX]: index !== -1 ? index : 0,
            // terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX
            ...(standortRoutingFnd || {}).path || {}
        };

    return { jahr, path, standort: standort || standorte[0] || veranstaltungen[0] || null, ...(entities.length && { entities }) };
}
